function mapEtatFiche(etatFiche) {
    switch (etatFiche) {
      case "0":
        return "Injoignable";
      case "1":
        return "Devis envoyé";
      case "2":
        return "Demande de rappel";
      case "3":
        return "Pas interessé / a déjà trouvé";
      case "4":
        return "Zotdevis";
      case "5":
        return "Non contacté";
      case "7":
        return "Devis validé";
      case "8":
        return "Stockage";
      default:
        return etatFiche;
    }
  }
export default mapEtatFiche;